import { API } from "./APIClient";

class MotivationAPIClass {
    async createMotivation() {

    }

    async fetchMotivation(employee_id) {
        const response = await API.get(`/motivation/employee/${employee_id}`);

        return {
            id: response.data.id,
            salaryPerHour: response.data.salary_per_hour,
            hoursPerShift: response.data.hours_per_shift,
            countShiftsMonthly: response.data.count_shifts_monthly,
            baseSalary: response.data.base_salary,
            avgRevenue: response.data.avg_revenue,
            bonusPercentage: response.data.bonus_percentage,
        };
    }
}

const MotivationAPI = new MotivationAPIClass();
export default MotivationAPI;
